export default __webpack_public_path__ + "static/media/bootstrap.ba1fb69f.png";